import {requestByPost} from '../../util/request'
import {API} from '@/util/api'
/**
 * 企业模块
 */
export default {
    namespaced: true,
    state: {
        // 这里放全局参数
    },
    getters: {
        // 这里放get方法 this.$store.getters['company/getMenus']
    },
    mutations: {
        // 这里是set方法  this.$store.commit('setDemoValue', value);
    },
    actions: {
      selectCompanyPage({ commit }, data) { // 企业列表，分页
          return requestByPost(API.selectCompanyPage, data)
      },
      selCompanyInfoPageFormEs ({ commit }, data) {
        return requestByPost(API.selCompanyInfoPageFormEs, data)
      },
      selCompanyReleaseInfoFormEs ({ commit }, data) {
        return requestByPost(API.selCompanyReleaseInfoFormEs, data)
      },
      selReleaseProdCasePageFormEs ({ commit }, data) {
        return requestByPost(API.selReleaseProdCasePageFormEs, data)
      },
      selReleaseBoutiquePhotoPage ({ commit }, data) {
        return requestByPost(API.selReleaseBoutiquePhotoPage, data)
      },
      queryProdTypeTreeSelect ({ commit }, data) {
        return requestByPost(API.queryProdTypeTreeSelect, data)
      },
      selProdInfoPageFormEs ({ commit }, data) {
        return requestByPost(API.selProdInfoPageFormEs, data)
      },
      saveOrDelUcFollowCompany ({ commit }, data) {
        return requestByPost(API.saveOrDelUcFollowCompany, data)
      },
      selByUserIdAndCompanyId ({ commit }, data) {
        return requestByPost(API.selByUserIdAndCompanyId, data)
      },
      queryByUserIdAndCompanyId ({ commit }, data) {
        return requestByPost(API.queryByUserIdAndCompanyId, data)
      },
      getProjectInfoById ({ commit }, data) {
        return requestByPost(API.getProjectInfoById, data, 0, 0, 1)
      },
      queryUserHaveCcCompany ({ commit }, data) {
        return requestByPost(API.queryUserHaveCcCompany, data)
      },
      querySysDictItemByDictId ({ commit }, data) {
        return requestByPost(API.querySysDictItemByDictId, data, 0, 0, 1)
      },
      freeTrySaasSystem ({ commit }, data) {
        return requestByPost(API.freeTrySaasSystem, data)
      },
      querySysDictItemByDictIdAndAppId ({ commit }, data) {
        return requestByPost(API.querySysDictItemByDictIdAndAppId, data, 0, 0, 1)
      },
      checkUserBindFactory ({ commit }, data) {
        return requestByPost(API.checkUserBindFactory, data, 0, 1)
      }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js